<template>
  <div class="small-icons-grid gap-2 flex flex-wrap justify-center md:justify-start">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
